import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const CreateUserModal = ({ onClose, onCreate }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    role: '',
    practice: '',
    location: '',
    status: 'Pending'
  });

  const [errors, setErrors] = useState({});

  const roleOptions = [
    { value: 'Provider', label: 'Provider' },
    { value: 'Practice Marketer', label: 'Practice Marketer' },
    { value: 'Administrator', label: 'Administrator' }
  ];

  const validateForm = () => {
    const newErrors = {};
    if (!formData?.name?.trim()) newErrors.name = 'Name is required';
    if (!formData?.email?.trim()) newErrors.email = 'Email is required';
    if (!formData?.role) newErrors.role = 'Role is required';
    if (!formData?.practice?.trim()) newErrors.practice = 'Practice name is required';
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      onCreate({
        ...formData,
        registrationDate: new Date()?.toISOString()?.split('T')?.[0],
        lastLogin: 'Never'
      });
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-lg shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto m-4">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-border sticky top-0 bg-card">
          <div>
            <h2 className="text-xl font-semibold text-foreground">Create New User</h2>
            <p className="text-sm text-muted-foreground mt-1">Add a new user to the platform</p>
          </div>
          <Button variant="ghost" size="sm" onClick={onClose} iconName="X" />
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <Input
            label="Full Name"
            placeholder="Enter full name"
            value={formData?.name}
            onChange={(e) => setFormData({ ...formData, name: e?.target?.value })}
            error={errors?.name}
            required
          />

          <Input
            label="Email Address"
            type="email"
            placeholder="user@example.com"
            value={formData?.email}
            onChange={(e) => setFormData({ ...formData, email: e?.target?.value })}
            error={errors?.email}
            required
          />

          <Select
            label="Role"
            options={roleOptions}
            value={formData?.role}
            onChange={(value) => setFormData({ ...formData, role: value })}
            placeholder="Select user role"
            error={errors?.role}
            required
          />

          <Input
            label="Practice Name"
            placeholder="Enter practice name"
            value={formData?.practice}
            onChange={(e) => setFormData({ ...formData, practice: e?.target?.value })}
            error={errors?.practice}
            required
          />

          <Input
            label="Location"
            placeholder="City, State"
            value={formData?.location}
            onChange={(e) => setFormData({ ...formData, location: e?.target?.value })}
          />

          <div className="bg-accent/10 border border-accent/20 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} className="text-accent mt-0.5" />
              <div>
                <p className="text-sm font-medium text-foreground">Invitation Email</p>
                <p className="text-xs text-muted-foreground mt-1">
                  An invitation email will be sent to the user with instructions to set up their
                  account and password.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-border bg-muted/30">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={handleSubmit}
            iconName="UserPlus"
            iconPosition="left"
          >
            Create User & Send Invitation
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CreateUserModal;